import React from 'react';
import '../components-css/footer.scss'
import AboutMe from "./about-me";


const AboutMeLongVersion = () => {
    return (
        <div>
            <div className={'wrapper'}>
                <AboutMe/>
            </div>
        </div>
    );
};

export default AboutMeLongVersion;
